import { CTAButton } from "component/button";
import { colorTextWarning } from "component/color";
import { FunctionalModal, Modal } from "component/modal";
import { UtilityText } from "component/text";
import { useState } from "react";
import { Image, View } from "react-native";
import { Locked as LockedIcon } from "@carbon/icons-react";
import { CLICK, component, componentWithVariants, demoFile, KEY_PRESS, POPUP, story, variant } from "system/demo";

demoFile('component/modal', {
    designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=6308-21252&t=MC9nppcf9h2iJDKP-1'
})

function ModalHolder({text, children}) {
    const [shown, setShown] = useState(false);

    const buttonRow = <CTAButton wide type='secondary' text='I understand' onPress={() => setShown(false)} />

    return <View>
        <CTAButton text={text} onPress={() => setShown(true)} />
        {shown && <Modal buttonRow={buttonRow} onClose={() => setShown(false)}>
            {children}
        </Modal>}
    </View>
}

const ESCAPE_KEYCODE = 27;


componentWithVariants('Modal', ModalHolder, {}, [
    variant('Small modal with buttons', {
        args: {text: 'Open Modal', children: <UtilityText text='chlidren' />}
    }, [
        story('Open', [
            CLICK('Open Modal')
        ]),
        story('Open and Close with button', [
            CLICK('Open Modal'), 
            POPUP(CLICK('I understand'))
        ]),
        story('Open and Close with breadcrumb', [
            CLICK('Open Modal'), 
            POPUP(CLICK('close-modal'))
        ]),
        story('Open and Close with Focus Loop', [
            CLICK('Open Modal'),
            POPUP(CLICK('end-focus-trap'))
        ]),
        story('Open and close with Focus Loop keyboard shortcut', [
            CLICK('Open Modal'),
            KEY_PRESS({keyCode: ESCAPE_KEYCODE}),
        ])
    ]),

    variant('Big Modal', {
        args: {text: 'Open Modal', children: 
            <Image 
                style={{width: 1000, height: 1000}} 
                source={{uri: 'https://psi.zdf.de/faces/face1.jpeg'}} 
            />
        }
    }, [
        story('Open', [
            CLICK('Open Modal')
        ])
    ])
])

function FunctionalModalHolder({headingText, descriptionText, confirmButton}) {
    const [shown, setShown] = useState(false);
    return <View>
        <CTAButton text='Open Modal' onPress={() => setShown(true)} />
        {shown && <FunctionalModal
            onClose={() => setShown(false)}
            onConfirm={() => setShown(false)}
            headingText={headingText}
            descriptionText={descriptionText}
            confirmButton={confirmButton}
        />}
    </View>
}

componentWithVariants('FunctionalModal', FunctionalModalHolder, {}, [
    variant('Basic modal', {
        args: {
            headingText: 'Close this space?',
            descriptionText: 'When closed, a space becomes “read only.” All actions are disabled and users cannot post, reply, react, report, etc. You can reopen the conversation at any time.',
            confirmButton: {
                label: 'Close',
                type: 'delete',
                icon: <LockedIcon color={colorTextWarning}/>,
            }
        }
    },
    [
        story('Open', [
            CLICK('Open Modal')
        ]),
    ]),
])


